'use client';

import { Container, Typography, Box, Button } from '@mui/material';
import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <Container maxWidth="sm">
      <Box sx={{ my: 4, textAlign: 'center' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Something went wrong!
        </Typography>
        <Typography variant="body1" color="text.secondary" gutterBottom>
          {error.message || 'An unexpected error occurred.'}
        </Typography>
        <Box sx={{ mt: 3 }}>
          <Button
            onClick={() => reset()}
            variant="contained"
            color="primary"
          >
            Try again
          </Button>
        </Box>
      </Box>
    </Container>
  );
} 